<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1">One</h1>
<p class="noindent">There was a knock at the door.</p>
<p class="p1">Mark Dalton didn't take his eyes off the computer screen in front of him. He was about to complete his game of solitaire and had been looking forward to seeing the cards fall and bounce all over the screen. Whoever it was could wait.</p>
<p class="p1">Another knock on the door, louder this time, and a little impatient.</p>
<p class="p1">"It's open," he said, but not before completing the game.</p>
<p class="p1">A moment later the door opened and a short bald guy in an off-the-rack grey suit stuck his shiny head into the office. "You Mark Dalton?"</p>
<p class="p1">"You a bill collector?"</p>
<p class="p1">"No."</p>
<p class="p1">"Then I'm Mark Dalton."</p>
<p class="p1">That seemed to satisfy the man and he stepped into the office, closing the door behind him gently, as if he knew someone was sleeping in an office down the hall.</p>
<p class="p1">"I need a private detective," he said.</p>
<p class="p1">Mark smiled, and almost said, "Then what are you doing here?" but managed to keep the joke to himself. Instead he said, "Then you've come to the right place."</p>
<p class="p1">The man stepped further into the office, taking a seat across the desk from Mark, but seemingly in no hurry to talk.</p>
<p class="p1">After a long silence, Mark asked, "What can I do for you?"</p>
<p class="p1">"It's my wife," he said.</p>
<p class="p1">Again Mark waited, but the man didn't add anything, so Mark had to prod him. "I'm a detective, not a mind reader. What kind of problem are you having with your wife?"</p>
<p class="p1">He looked left and right, then said. "I think she's seeing someone else."</p>
<p class="p1">As a private investigator specializing in divorce cases, Mark had been through this routine plenty of times before. No one who came to him was in a real mood to talk about their problems, so Mark usually had to prod them with a few tried but true phrases.</p>
<p class="p1">"Oh, yeah?" Mark said.</p>
<p class="p1">"Yes, and I think she's having sex with someone else."</p>
<p class="p1">"That so."</p>
<p class="p1">The man nodded. "I'm fairly certain of it."</p>
<p class="p1">"You seen her with somebody?"</p>
<p class="p1">"No."</p>
<p class="p1">"Strange phone calls to the house?"</p>
<p class="p1">"No."</p>
<p class="p1">"She staying out late at night?"</p>
<p class="p1">"Not really."</p>
<p class="p1">Mark was starting to get annoyed. "Then how do you know she's seeing somebody else?"</p>
<p class="p1">"Well," he said. "The last few times we've... well, had sex. She didn't seem very interested."</p>
<p class="p1">Mark stared at the man, managing to keep a straight face, but only just. The guy was very wide around the middle, well on his way to three-hundred pounds, and fooling no one with that ridiculous bit of comb-over. If his wife wasn't interested in having sex with him, an affair was the end result of her disinterest, not the reason for it.</p>
<p class="p1">But to be fair, Mark had no idea what the guy's wife looked like. Maybe she wasn't a looker either, and the two of them simply grew apart — simple as that. Besides, Mark knew he shouldn't be too quick to pass judgement on the guy since his own marriage hadn't been going so smooth lately either.</p>
<p class="p1">So instead of cracking wise, Mark just said, "Geez, that sounds rough."</p>
<p class="p1">For a moment the guy looked like he was going to cry, but he managed to hold back his tears. "Very rough, especially since we've always been so good together."</p>
<p class="p1">Mark nodded. It was obvious the man was hurting. "So what do you want me to do?"</p>
<p class="p1">"I'd like you to follow her for a couple of weeks, find out if she's seeing someone else for sure."</p>
<p class="p1">"You want video?"</p>
<p class="p1">"I want proof, one way or another." It was a statement rather than an answer to the question.</p>
<p class="p1">"Video will cost you more," Mark said, outlining his fees.</p>
<p class="p1">"Just get me proof," he said.</p>
<p class="p1">"I'll do my best."</p>
<p class="p1">And then the man took out his check book and cut a four-figure check just to get Mark started. "Call me when you have it."</p>
<p class="p1">Mark took the check, glanced at it, then flipped it onto his desk as if he could do without the work. Even though he hadn't taken on a new case in weeks, no one was ever impressed by a private detective who was thrilled about the prospect of a job. The trick was to look like you were always in demand, even when you weren't.</p>
<p class="p1">"I'll be in touch," he said.</p>
<p class="p1">Mark nodded. "If I'm not in, leave a message."</p>
<p class="p1">The man left the office, and when Mark was sure he was down the stairs and out of the building, he picked up the check again and stared at it for a full half-hour, a wide grin on his face the whole time.<br style="clear:both;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter11.vue?787f10ef